import React, { useEffect, useRef, useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  useMap,
  FeatureGroup,
  FeatureGroupProps,
  useMapEvents,
  Polygon,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "mapbox-gl-leaflet";
import { useTranslate } from "../../hooks/LanguageProvider";
import IconMarker from "../../components/Map/IconItinerary";
import { Row } from "react-bootstrap";
import "../../components/Map/map.css";
import "leaflet/dist/leaflet.css";
import MarkerClusterGroup from "react-leaflet-cluster";

import {
  engineStat,
  engineStatClass,
  handleDownloadExcel,
  parseServerUtcDate,
  toTimestamp,
} from "../../utilities/functions";
import { useSpring, animated } from "react-spring";
import {
  LatLngBounds,
  LatLngBoundsExpression,
  LatLngBoundsLiteral,
  LatLngExpression,
  LatLngLiteral,
} from "leaflet";
import L from "leaflet";
import PopupItinerary from "../Map/PopupItinerary";
import RouteSimulator from "../Map/RouteSimulator";
import { usePulseIcon } from "../Map/usePulseIcon";

import { lineString, bezierSpline } from "@turf/turf";

import FullscreenControlCustom from "../Map/FullscreenControlCustom";
import ZoomControl from "../ui/ZoomControl";
import { toast } from "react-toastify";
import PrintControl from "../Map/PrintControl";
import BaseMapLayerControl from "../Map/BaseMapLayerControl";
import { BaseMapValue } from "../../config/maps/baseMaps";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface VehicleWidgetProps {
  type_report?: string;
  turn?: string;
  id_report?: string;
}

const Report1: React.FC<VehicleWidgetProps> = ({
  type_report,
  turn,
  id_report,
}) => {
  interface itinerary {
    id: number;
    start: string;
    end: string;
    name: string;
    distance: number;
    ALT: number;
    LAT: number;
    LNG: number;
    COG: number;
    SOG: number;
    ENGINESTAT?: number;
    ALARMS: string;
    PRIVATE_MODE: number;
  }

  const center: [number, number] = [30.5670197, 4.6911217];
  const zoom: number = 5;
  const MaxZoom: number = 19;
  const MinZoom: number = 5;
  const { translate } = useTranslate();
  const user_id = localStorage.getItem("user_id");
  const [itineraries, setItineraries] = useState<itinerary[]>([]);
  const [dateStart, setDateStart] = useState<string>("");
  const [dateEnd, setDateEnd] = useState<string>("");
  const [baseMap, setBaseMap] = useState<BaseMapValue>("google_roadmap");
  const [listLayout, setlistLayout] = useState("");
  const [mapLayout, setMapLayout] = useState("col-10");
  const [clicked, setClicked] = useState(false);
  const [ungroupMarker, setUngroupMarker] = useState<boolean>(true);
  const [selectedDayMarkers, setSelectedDayMarkers] = useState<MarkerData[]>([]);
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [selectedTimes, setSelectedTimes] = useState<Record<string, number[]>>({});
  const [vehicleState, setVehicleState] = useState<string | null>(null);
  const routeGroupRef = useRef<L.LayerGroup | null>(null);
  const markerGroupRef = useRef<L.LayerGroup | null>(null);
  const initializedRef = useRef(false);   // â† indique si lâ€™init a dÃ©jÃ  Ã©tÃ© faite
  const [itineraryByDay, setItineraryByDay] = useState<{ [day: string]: itinerary[]; }>({});
  const [selectedDay, setSelectedDay] = useState<string | null>(null);


  useEffect(() => {
    if (initializedRef.current) return;           // dÃ©jÃ  initialisÃ©Â ? on sort

    const dayKeys = Object.keys(itineraryByDay);
    if (dayKeys.length === 0) return;             // pas encore de donnÃ©es

    const firstDay = dayKeys[0];                  // 1Ê³áµ‰ journÃ©e trouvÃ©e

    /* â€”Â SÃ©lectionne UNIQUEMENT cette journÃ©eÂ â€” */
    setSelectedDays([firstDay]);

    const allIndexes = itineraryByDay[firstDay].map((it) =>
      itineraries.findIndex((x) => x === it)      // index globaux
    );
    setSelectedTimes({ [firstDay]: allIndexes });

    initializedRef.current = true;                // on ne repassera plus ici
  }, [itineraryByDay, itineraries]);


  const mapRef = useRef<any>(null);

  const MapEventHandler: React.FC<{
    onMapReady: (mapInstance: any) => void;
  }> = ({ onMapReady }) => {
    const map = useMap();
    useEffect(() => {
      if (map) {
        onMapReady(map);
        // Appeler la fonction lorsque la carte est prÃªte
      }
    }, [map]);
    return null;
  };

  interface toChartData {
    x: number;
    y: number;
  }

  // Remplacez la dÃ©claration de GroupComponent par ceci
  var GroupComponent: React.ComponentType<any> = ungroupMarker
    ? MarkerClusterGroup
    : FeatureGroup;

  interface Vehicle {
    id_vehicule: number;
    immatriculation_vehicule: string;
    LAT: number;
    LNG: number;
    SOG: number;
    COG: number;
    ENGINESTAT: number;
    TIMESTAMP: string;
    GPSDIST: number;
    PSN: string;
  }

  // DÃ©finir l'animation de clic avec react-spring
  const animationProps = useSpring({
    transform: clicked ? "scale(1.1)" : "scale(1)",
    overflow: "hidden",
    marginTop: clicked ? "55px" : "10px",
  });

  function ToUTCTime(isoDateString: string): number {
    if (!isoDateString) {
      return 0; // Ou une valeur par dÃ©faut appropriÃ©e
    }

    const dateComponents = isoDateString.split(/[-T:.Z]/);
    const start_date = dateComponents.map((component) =>
      parseInt(component, 10)
    );

    return Date.UTC(
      start_date[0],
      start_date[1] - 1,
      start_date[2],
      start_date[3],
      start_date[4],
      start_date[5],
      0
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  interface MarkerData {
    LAT: number;
    LNG: number;
  }

  interface MapContentProps {
    markers: MarkerData[];
  }

  // DÃ©finir un tableau de couleurs pour chaque jour de la semaine
  const colors = [
    "#00B3E6",
    "#E6B333",
    "#3366E6",
    "#999966",
    "#99FF99",
    "#B34D4D",
    "#80B300",
    "#809900",
    "#E6B3B3",
    "#6680B3",
    "#66991A",
    "#FF99E6",
    "#CCFF1A",
    "#FF1A66",
    "#E6331A",
    "#33FFCC",
    "#66994D",
    "#B366CC",
    "#4D8000",
    "#B33300",
    "#CC80CC",
    "#66664D",
    "#991AFF",
    "#E666FF",
    "#4DB3FF",
    "#1AB399",
    "#E666B3",
    "#33991A",
    "#CC9999",
    "#B3B31A",
    "#00E680",
    "#4D8066",
    "#809980",
    "#E6FF80",
    "#1AFF33",
    "#999933",
    "#FF3380",
    "#CCCC00",
    "#66E64D",
    "#4D80CC",
    "#9900B3",
    "#E64D66",
    "#4DB380",
    "#FF4D4D",
    "#99E6E6",
    "#6666FF",
    "#00B3E6",
    "#E6B333",
    "#3366E6",
    "#999966",
    "#99FF99",
    "#B34D4D",
    "#80B300",
    "#809900",
    "#E6B3B3",
    "#6680B3",
    "#66991A",
    "#FF99E6",
    "#CCFF1A",
    "#FF1A66",
    "#E6331A",
    "#33FFCC",
    "#66994D",
    "#B366CC",
    "#4D8000",
    "#B33300",
    "#CC80CC",
    "#66664D",
    "#991AFF",
    "#E666FF",
    "#4DB3FF",
    "#1AB399",
    "#E666B3",
    "#33991A",
    "#CC9999",
    "#B3B31A",
    "#00E680",
    "#4D8066",
    "#809980",
    "#E6FF80",
    "#1AFF33",
    "#999933",
    "#FF3380",
    "#CCCC00",
    "#66E64D",
    "#4D80CC",
    "#9900B3",
    "#E64D66",
    "#4DB380",
    "#FF4D4D",
    "#99E6E6",
    "#6666FF",
  ];
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // â¬‡ï¸Ž remplace l'entÃªte et le contenu de la fonction existante
  const getVisibleItinerariesForDay = (day: string) => {
    const visibleTimes = selectedTimes[day] || [];
    if (visibleTimes.length === 0) return [];

    return (itineraryByDay[day] || []).filter((it) => {
      const isSelected = visibleTimes.includes(itineraries.findIndex((x) => x === it));
      const matchesFilter = !vehicleState || getItineraryState(it) === vehicleState;
      return isSelected && matchesFilter;
    });
  };

  const flyToMarkers = (map: L.Map, days: string[]) => {
    if (!map) return;

    // 1. (rÃ©)initialiser le LayerGroup unique
    if (!routeGroupRef.current) {
      routeGroupRef.current = L.layerGroup().addTo(map);
    } else {
      routeGroupRef.current.clearLayers();          // ðŸ”‘ supprime les anciens tracÃ©s
    }

    // 2. Afficherâ€¯: UNE polyline par journÃ©e cochÃ©e
    days.forEach((day) => {
      const dayItineraries = getVisibleItinerariesForDay(day);
      if (!dayItineraries || dayItineraries.length < 2) return;

      // tableau de tuples [lat,lng]
      const positions: [number, number][] = dayItineraries.map((it) => [
        Number(it.LAT),
        Number(it.LNG),
      ]);

      // BÃ©zier Turf
      const geo = lineString(positions.map(([lat, lng]) => [lng, lat]));
      const curved = bezierSpline(geo, { resolution: 10000, sharpness: 0.85 });
      const smooth: [number, number][] = geo.geometry.coordinates.map(
        ([lng, lat]) => [lat, lng]
      );

      const color = colors[getDay(dateEnd) - getDay(day)] || "#ff4d00";

      L.polyline(smooth, {
        color,
        weight: 5,
        opacity: 0.65,
        smoothFactor: 1,
      }).addTo(routeGroupRef.current!);
    });
  };


  // Fonction pour calculer les limites Ã  partir des coordonnÃ©es des marqueurs
  const calculateBounds = (
    markerLatLngs: LatLngLiteral[]
  ): LatLngBoundsLiteral => {
    let minLat = Number.POSITIVE_INFINITY;
    let maxLat = Number.NEGATIVE_INFINITY;
    let minLng = Number.POSITIVE_INFINITY;
    let maxLng = Number.NEGATIVE_INFINITY;

    for (const { lat, lng } of markerLatLngs) {
      minLat = Math.min(minLat, lat);
      maxLat = Math.max(maxLat, lat);
      minLng = Math.min(minLng, lng);
      maxLng = Math.max(maxLng, lng);
    }

    return [
      [minLat, minLng],
      [maxLat, maxLng],
    ];
  };

  const MapCenter: React.FC<{ markers: MarkerData[] }> = ({ markers }) => {
    const map = useMap();

    useEffect(() => {
      if (!map || markers.length === 0) return;

      if (isInitialLoad) {
        // Centrage global au chargement
        const latLngs = markers.map((m) => ({ lat: m.LAT, lng: m.LNG }));
        const bounds = calculateBounds(latLngs);
        map.fitBounds(bounds);
        setIsInitialLoad(false); // dÃ©sactiver pour les clics suivants
      }
      // Ne rien faire aprÃ¨s
    }, [map, markers]);

    return null;
  };

  const MapContent: React.FC = () => {
    const map = useMap();

    useEffect(() => {
      if (selectedItem) {
        // console.log(selectedItem.id_vehicule);

        const { LAT, LNG } = selectedItem;

        map.flyTo([LAT, LNG], 15, {
          // animate: false,
          duration: 1,
        });
      }
    }, [map, selectedItem]);

    return null;
  };

  const [selectedItem, setSelectedItem] = useState<Vehicle | null>(null);

  useEffect(() => {
    const getItineraries = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/report1/${id_report}`, {
          mode: "cors",
        });

        if (response.ok) {
          const data = await response.json();
          const itineraries = data["repportDatas"];

          // âœ… Ignore les itinÃ©raires sans coordonnÃ©es valides
          const cleaned = itineraries.filter(
            (it: any) =>
              it.LAT !== null &&
              it.LNG !== null &&
              !isNaN(Number(it.LAT)) &&
              !isNaN(Number(it.LNG))
          );

          if (cleaned.length === 0) {
            console.warn("Aucune coordonnÃ©e valide trouvÃ©e dans les donnÃ©es reÃ§ues");
            toast.warn("Aucun itinÃ©raire valide trouvÃ© dans les donnÃ©es reÃ§ues.", {
              position: "bottom-right",
            });
          }

          // âœ… On travaille dÃ©sormais UNIQUEMENT avec cleaned
          setItineraries(cleaned);

          if (cleaned.length === 0) return; // rien Ã  traiter ensuite

          setDateStart(toTimestamp(cleaned[0].start).split(" ")[0]);
          setDateEnd(
            toTimestamp(cleaned[cleaned.length - 1].start).split(" ")[0]
          );

          // CrÃ©er un objet pour stocker les itinÃ©raires par jour
          const itineraryByDayObj: { [day: string]: itinerary[] } = {};

          // Remplir l'objet avec les itinÃ©raires correspondants Ã  chaque jour
          cleaned.forEach((itinerary: itinerary) => {
            const day = toTimestamp(itinerary.start).split(" ")[0];
            if (!itineraryByDayObj[day]) {
              itineraryByDayObj[day] = [];
            }
            itineraryByDayObj[day].push(itinerary);
          });

          setItineraryByDay(itineraryByDayObj);

          // SÃ©lectionner toutes les journÃ©es
          const allDays = Object.keys(itineraryByDayObj);

          // SÃ©lectionner toutes les heures pour chaque journÃ©e
          const allTimes: Record<string, number[]> = {};
          for (const day of allDays) {
            allTimes[day] = itineraryByDayObj[day].map((it) =>
              cleaned.findIndex((x: any) => x === it)
            );
          }
          setSelectedTimes(allTimes);

          // DÃ©finir la premiÃ¨re journÃ©e comme sÃ©lectionnÃ©e
          const firstDay = Object.keys(itineraryByDayObj)[0];
          setSelectedDay(firstDay);
        } else {
          console.error("Failed to fetch vehicle data");
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };

    getItineraries();
  }, [id_report]);



  const [triggerDayFocus, setTriggerDayFocus] = useState(false);


  useEffect(() => {
    if (!triggerDayFocus || !selectedDay || !mapRef.current || !itineraryByDay[selectedDay]) return;

    const map = mapRef.current;
    const dayMarkers = itineraryByDay[selectedDay].map((item) => ({
      lat: item.LAT,
      lng: item.LNG,
    }));

    if (dayMarkers.length > 0) {
      const bounds = calculateBounds(dayMarkers);
      map.fitBounds(bounds);
    }

    setTriggerDayFocus(false); // dÃ©sactive pour ne pas relancer sans clic
  }, [triggerDayFocus, selectedDay, itineraryByDay]);


  useEffect(() => {
    // Mettre Ã  jour les marqueurs de la journÃ©e sÃ©lectionnÃ©e
    const markers = selectedDay
      ? itineraryByDay[selectedDay]?.map((itinerey) => ({
        LAT: itinerey.LAT,
        LNG: itinerey.LNG, // Utiliser LNG au lieu de LNG, si c'est ce que vous utilisez dans votre type MarkerData
      })) || []
      : [];
    // console.log("Selected day markers updated:", markers); //
    setSelectedDayMarkers(markers);
  }, [selectedDay, itineraryByDay]);


  // âž¤ Trace ou retrace l'itinÃ©raire quand la liste de marqueurs change
  useEffect(() => {
    if (mapRef.current) {
      flyToMarkers(mapRef.current, selectedDays);   // ðŸ” redessine
    }
  }, [selectedDays, selectedTimes, itineraryByDay, vehicleState]);


  // Fonction pour calculer la diffÃ©rence en heures entre deux timestamps
  function calculateHoursDifference(
    timestamp1: string,
    timestamp2: string
  ): number {
    const diffInMilliseconds =
      parseServerUtcDate(timestamp1).getTime() - parseServerUtcDate(timestamp2).getTime();
    return diffInMilliseconds / (1000 * 60 * 60);
  }

  const handleItemClick = (item: itinerary) => {
    // console.log(item);
  };

  const handleGroupMarker = () => {
    ungroupMarker == false ? setUngroupMarker(true) : setUngroupMarker(false);
  };

  const containerRef = useRef<HTMLDivElement>(null);

  const handleWheelScroll = (event: React.WheelEvent<HTMLDivElement>) => {
    event.stopPropagation();
    // console.log("Wheel event triggered");
    const container = containerRef.current;
    if (container) {
      container.scrollTop += event.deltaY;
    }
  };

  const mapLayoutClick = () => {
    listLayout == "layoutfloat"
      ? setlistLayout("layoutleft")
      : setlistLayout("layoutfloat");
    mapLayout == "col-12" ? setMapLayout("col-10") : setMapLayout("col-12");
    // console.log('Clic sur map-layout');
  };

  const handleMarker = (state: string) => {
    if (vehicleState === state) {
      setVehicleState(null); // If the filter is already selected, clear the filter
    } else {
      setVehicleState(state); // Otherwise, apply the filter
    }
  };

  const normalizeItineraryName = (value: string = "") => {
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const getItineraryEngineState = (itinerary: itinerary) => {
    if (typeof itinerary.ENGINESTAT === "number") return itinerary.ENGINESTAT;

    const normalizedName = normalizeItineraryName(itinerary.name);
    if (
      normalizedName.includes("arrete") ||
      normalizedName.includes("moteur arr") ||
      normalizedName.includes("stopped")
    ) {
      return 0;
    }
    return 1;
  };

  const getItineraryState = (itinerary: itinerary): "move" | "pause" | "stop" => {
    return engineStatClass(
      getItineraryEngineState(itinerary),
      Number(itinerary.SOG) || 0
    ) as "move" | "pause" | "stop";
  };

  const getItineraryIconName = (itinerary: itinerary) => {
    return getItineraryEngineState(itinerary) === 0 ? "Moteur arrete" : "Moteur demarre";
  };

  const handleDownloadReportExcel = () => {
    if (itineraries.length === 0) {
      toast.warn(translate("No data available"), { position: "bottom-right" });
      return;
    }

    const rows = itineraries.map((itinerary, index) => {
      const state = getItineraryState(itinerary);
      return {
        "#": index + 1,
        [translate("Start date")]: toTimestamp(itinerary.start),
        [translate("End date")]: toTimestamp(itinerary.end),
        [translate("Status")]: translate(
          state === "move"
            ? "Engine running"
            : state === "pause"
              ? "Parking with engine started"
              : "Parking"
        ),
        [translate("Speed")]: Number(itinerary.SOG) || 0,
        [translate("Distance")]: `${((Number(itinerary.distance) - Number(itineraries[0]?.distance || 0)) / 1000).toFixed(2)} Km`,
        LAT: itinerary.LAT,
        LNG: itinerary.LNG,
        ALT: itinerary.ALT,
        COG: itinerary.COG,
        [translate("Alarms")]: itinerary.ALARMS || "",
      };
    });

    handleDownloadExcel(rows, `itinerary-reconstitution-${id_report || "report"}`);
  };

  const timeZone = (datetime: string) => toTimestamp(datetime);

  /*****************************************Last Update */

  const [expandedDays, setExpandedDays] = useState<string[]>([]);

  const toggleAllDay = (day: string) => {
    setSelectedDay(day);
    setTriggerDayFocus(true);
    setExpandedDays((prevExpandedDays) => {
      if (prevExpandedDays.includes(day)) {
        return prevExpandedDays.filter((d) => d !== day);
      } else {
        return [...prevExpandedDays, day];
      }
    });
  };



  const checkDay = (day: string) => {
    setSelectedDay(day);
    const dayItineraries = itineraryByDay[day] || [];
    if (dayItineraries.length === 0) return; // rien Ã  faire si pas de data

    setSelectedTimes((prev) => {
      const currentTimes = prev[day] || [];

      const allTimes = dayItineraries.map((it) =>
        itineraries.findIndex((x) => x === it)      // âœ… index global dans itineraries
      );

      const allChecked = allTimes.every((t) => currentTimes.includes(t));

      if (allChecked) {
        // âœ… Tout Ã©tait cochÃ© â†’ on dÃ©coche tout
        const updated = { ...prev };
        delete updated[day];
        setSelectedDays((d) => d.filter((x) => x !== day));
        return updated;
      } else {
        // âœ… On coche toutes les heures pour ce jour
        setSelectedDays((d) =>
          d.includes(day) ? d : [...d, day]
        );
        return { ...prev, [day]: allTimes };
      }
    });
  };




  const checkTime = (day: string, index: number) => {
    setSelectedDay(day);
    setSelectedTimes((prev) => {
      const current = prev[day] || [];
      const updated = current.includes(index)
        ? current.filter((i) => i !== index)
        : [...current, index];

      setSelectedDays((days) =>
        updated.length === 0
          ? days.filter((d) => d !== day)
          : days.includes(day)
            ? days
            : [...days, day]
      );

      return { ...prev, [day]: updated };
    });
  };
  // IMPORT dÃ©jÃ  prÃ©sent en haut : import L from "leaflet";

  const goToPosition = (lat: number, lng: number) => {
    const map = mapRef.current as L.Map | null;
    if (!map) return;

    // Centrer la carte
    map.flyTo([lat, lng], 17, { duration: 0.7 });

    // Parcourir toutes les couches et ouvrir le popup du marqueur ciblÃ©
    map.eachLayer((layer: any) => {
      if (layer instanceof L.Marker) {
        const pos = layer.getLatLng();
        const samePoint =
          Math.abs(pos.lat - lat) < 1e-6 && Math.abs(pos.lng - lng) < 1e-6; // tolÃ©rance flottante
        if (samePoint) {
          layer.openPopup();
        }
      }
    });
  };


  interface MarkerData {
    LAT: number;
    LNG: number;
  }

  const getDay = (dateStr: string): number => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, "0"); // Ajouter un 0 devant les jours de 1 Ã  9
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Les mois sont de 0 Ã  11
    const year = date.getFullYear();
    return parseInt(day); // Format: jj/mm/aaaa
  };




  const renderList = (
    itinerey: itinerary,
    itineraries: itinerary[],
    day: string,
    isExpanded: boolean,
    state: string,
    i: number
  ) => {
    if (!itinerey) return null;

    const inputId = `tchk_${day}_${i}`;
    const isChecked = Array.isArray(selectedTimes[day]) && selectedTimes[day].includes(i);

    const commonCheckbox = (
      <div className={`trips_${day} ${isExpanded ? "show" : "hide"}`} style={{ paddingLeft: "16px" }}>
        <div
          id={`trip_${i}`}
          className={state}
          style={{
            minWidth: "100%",
            float: "left",
            display: !isExpanded ? "none" : "block",
          }}
        >
          <div className="checkbox" style={{ float: "left" }}>
            <input
              id={inputId}
              type="checkbox"
              className={`tchk_${day} tchk_${i}`}
              onChange={() => {
                checkTime(day, i);
              }}
              checked={isChecked}
              name={`tchk_${day}`}
              value={day}
            />
            <label htmlFor={inputId}> </label>

            <a
              onClick={() => {
                goToPosition(itinerey.LAT, itinerey.LNG);
              }}
              style={{
                marginLeft: "8px",
                cursor: "pointer",
                textDecoration: "none",
                "fontSize": "13px"
              }}
              className="marker"
            >
              <i
                className={`fa ${state === "stop" ? "fa-pause" : "fa-stop"}`}
                style={{ color: state === "stop" ? "blue" : "red" }}
              ></i>{" "}
              {toTimestamp(itinerey.start).split(" ")[1]} - {toTimestamp(itinerey.end).split(" ")[1]}
              <span
                style={{
                  marginLeft: "3px",
                  color: "#000",
                  fontSize: "0.9em",
                }}
              >
                {`${((itinerey.distance - itineraries[0].distance) / 1000).toFixed(2)} Km`}
              </span>
            </a>
          </div>
        </div>
      </div>
    );

    if (state === "stop") {
      return <>{commonCheckbox}</>;
    }

    if (state === "pause") {
      return <>{commonCheckbox}</>;
    }

    return null;
  };

  const currentPath: [number, number][] =
    selectedDay
      ? getVisibleItinerariesForDay(selectedDay).map((it) => [it.LAT, it.LNG])
      : [];

  const pulseIcon = usePulseIcon();


  return (
    <>
      <Row>
        <div
          className={`${listLayout} col-12 col-md-2`}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "86vh",
            margin: "20px 0",
            paddingLeft: "30px",
          }}
        >
          <div style={{ margin: "0px 0 15px 0" }} className="">
            <button
              type="button"
              data-toggle="tooltip"
              className={`btn btn-default btn-sm pull-left act ${vehicleState !== "move" ? "active" : ""
                }`}
              id="act_moving"
              onClick={() => handleMarker("move")}
              title="Engine running"
            >
              <i
                className="la la-play-circle"
                style={{ color: "green", fontSize: "20px" }}
              ></i>
            </button>
            <button
              type="button"
              data-toggle="tooltip"
              className={`btn btn-delault btn-sm pull-left act ${vehicleState !== "pause" ? "active" : ""
                }`}
              id="act_pause"
              onClick={() => handleMarker("pause")}
              title="Parking with engine started"
            >
              <i
                className="la la-pause-circle"
                style={{ color: "red", fontSize: "20px" }}
              ></i>
            </button>
            <button
              type="button"
              data-toggle="tooltip"
              className={`btn btn-delault btn-sm pull-left act ${vehicleState !== "stop" ? "active" : ""
                }`}
              id="act_stoping"
              onClick={() => handleMarker("stop")}
              title="Parking"
            >
              <i
                className="las la-stop-circle"
                style={{ color: "blue", fontSize: "20px" }}
              ></i>
            </button>
            <button
              type="button"
              data-toggle="tooltip"
              className="btn btn-delault btn-sm pull-left act"
              id="act_regrouper"
              onClick={() => handleGroupMarker()}
              title="Group or ungroup vehicles"
            >
              <i
                className="la la-object-ungroup"
                style={{ color: "#000", fontSize: "20px" }}
              >
                {" "}
              </i>
            </button>
            {/* <span className='map-layout' onClick={mapLayoutClick}>
              <i className="las la-list" data-rel="bootstrap-tooltip" title="Increased" style={{ fontSize: "24px" }}></i>
            </span> */}
          </div>

          <div
            className="well well-sm"
            id="track_dates"
            style={{
              background: "#fff",
              flex: "1 1 auto",
              marginTop: "5px",
              padding: "3px",
              overflowY: "auto",
              minHeight: "140px",
            }}
            data-dist-src="gps"
          >
            {itineraries.map((itinerey, i) => {
              const day = toTimestamp(itinerey.start).split(" ")[0].trim();
              const state = getItineraryState(itinerey);
              const sidebarItinerary =
                state === "stop"
                  ? { ...itinerey, name: "Moteur arrêté" }
                  : state === "pause"
                    ? { ...itinerey, name: "Moteur démarré", SOG: 0 }
                    : itinerey;
              const isExpanded = expandedDays.includes(day);

              return (
                <React.Fragment key={i}>
                  {i === 0 ||
                    day !== toTimestamp(itineraries[i - 1].start).split(" ")[0] ? (
                    <div
                      id={day}
                      style={{ display: "inline-block", minWidth: "100%" }}
                    >
                      <div className="checkbox" style={{ float: "left" }}>
                        <i
                          className="fa fa-fw fa-caret-right"
                          style={{ visibility: "visible" }}
                          onClick={() => toggleAllDay(day)}
                        ></i>
                        <input
                          id={`chk_${day}`}
                          type="checkbox"
                          onChange={() => checkDay(day)}
                          checked={selectedDays.includes(day)}
                        // value={day}
                        />
                        <label htmlFor={`chk_${day}`}></label>
                        <a
                          id={`day_${day}`}
                          onClick={() => toggleAllDay(day)}
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                            marginLeft: "3px",
                            fontWeight: "bold",
                            "fontSize": "14px"
                          }}
                        >
                          {day}
                        </a>
                      </div>
                    </div>
                  ) : null}

                  {(!vehicleState || vehicleState === state) &&
                    renderList(sidebarItinerary, itineraries, day, isExpanded, state, i)}
                </React.Fragment>
              );
            })}
          </div>
          <div
            style={{
              display: "flex",
              flex: "0 0 auto",
              justifyContent: "flex-end",
              marginTop: "10px",
              paddingRight: "6px",
            }}
          >
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={handleDownloadReportExcel}
              title={translate("Download Excel")}
              style={{
                alignItems: "center",
                display: "inline-flex",
                gap: "6px",
                minHeight: "32px",
              }}
            >
              <i className="fa fa-download" aria-hidden="true"></i>
              <span>Excel</span>
            </button>
          </div>
        </div>
        <div className={mapLayout} style={{ padding: "0px" }}>
          <MapContainer
            center={center}
            zoom={zoom}
            minZoom={MinZoom}
            maxZoom={MaxZoom}
            zoomControl={false}
            style={{
              padding: 0,
              margin: 0,
              height: "86vh",
              width: "100%",
              zIndex: 1,
            }}
          >
            <MapContent />
            {currentPath.length > 1 && (
              <RouteSimulator
                path={currentPath}
                speed={70}            // km/h virtuels (ajuste Ã  ton goÃ»t)
                autofit={false}
              // on garde le zoom actuel
              />
            )}

            <BaseMapLayerControl
              value={baseMap}
              onChange={setBaseMap}
              tokenUrl={`${backendUrl}/api/mapkit/token`}
              top={132}
            />
            <GroupComponent>
              {selectedDays.flatMap((day) => {
                return getVisibleItinerariesForDay(day)
                  .map((it) => (
                    <Marker
                      key={`${it.id}-${it.start}`}
                      position={[it.LAT, it.LNG]}
                      icon={IconMarker(it.COG, it.SOG, getItineraryIconName(it), () => handleItemClick(it))}
                    >
                      <PopupItinerary itinerary={it} />
                    </Marker>
                  ));
              })}
            </GroupComponent>
            <ZoomControl position="topright" />
            <FullscreenControlCustom position="topright" />
            <PrintControl
              position="topright"
              orientation="landscape"
              pageSize="A4"
              fitOnPrint="selection"
              selectionEnabled={true}
            />
            <MapCenter markers={selectedDayMarkers} />
            <MapEventHandler
              onMapReady={(mapInstance) => {
                mapRef.current = mapInstance;
                flyToMarkers(mapInstance, selectedDays);   // â† uniquement les jours cochÃ©s
              }}
            />
          </MapContainer>
        </div>
      </Row>
    </>
  );
};

export default Report1;
